module.exports = __webpack_public_path__ + "static/media/entrance.98ce35fe.svg";